import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { CommonService }            from './common.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class OrderLogisticalService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'OrderLogistical', snackbar);
    }

    public getSalesData(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('SalesData', filter);
    }

    public getOrderData(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('OrderData', filter);
    }

    public getHistoryData(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('ProductHistory', filter);
    }

    public initializeNewCyle(sourceCycle: string, newCycle: string): Observable<any> {
        return this._commonService.post('InitializeNewCycle', { 'sourceCycle': sourceCycle, 'newCycle': newCycle });
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/order-logistical.service.ts